import {AccessToken} from "./types";
import {useMateApi} from "./useMateApi";

export interface ReportEngineSettingsResponse {
    reportId: string;
    url: string;
    token: string;
    tenants: string[];
}

export const useReportEngineApi = (accessToken: AccessToken) => {
    
    const {jsonEndpoint} = useMateApi(accessToken);
    const api = jsonEndpoint("/api/report-engine/report-settings");

    const getReportEngineResponse = (reportSettings: any) => {
        return api.post<ReportEngineSettingsResponse>(reportSettings);
    }
    
    return {
        getReportEngineResponse: getReportEngineResponse
    }
}